import { StackShim as Stack, StackItemShim as StackItem } from '@fluentui/react-migration-v8-v9';
import { makeStyles } from '@fluentui/react-components';
import React, { useState } from 'react';
import { bodyContentContainer } from '../../../app/common/styles/CommonStyleObjects';
import { GetProcessExtensionsWithPaginationQuery } from '../../../utils/statApi/ProcessExtensionApi';
import IProcessExtensionsListItem from '../../../utils/types/IProcessExtensionsListItem';
import WrappedListPage, {
  IPaginatedListPageProps,
} from '../../common/DetailsLists/pagination/PaginatedListPage';
import FullWidthHeader from '../../common/headers/FullWidthHeader';
import ListFilter from './ListFilter';
import ProcessExtensionsList from './ProcessExtensionsList';

export interface IProcessExtensionsListPageState {
  statusIds: number[];
  assignments: string[];
  processTypeIds: number[];
}

const useStyles = makeStyles({
  filterItem: { marginRight: '50px', marginTop: '30px' },
});

const ProcessExtensionsListPage = (): JSX.Element => {
  const classes = useStyles();
  const [filterState, setFilterState] = useState<IProcessExtensionsListPageState>({
    statusIds: [1],
    assignments: ['APPROVER', 'OWNER'],
    processTypeIds: [],
  });

  const renderHeader = (): JSX.Element => <h1>Process Extensions</h1>;

  const wrappedListPageParams: IPaginatedListPageProps<IProcessExtensionsListItem> = {
    dataMapperKey: 'processExtensions',
    actionName: 'loading the process extensions list',
    query: GetProcessExtensionsWithPaginationQuery,
    filters: filterState,
    emptyResultMessage:
      'There are no process extension requests with the selected filters. Try selecting some different options.',
  };
  return (
    <>
      <Stack horizontal horizontalAlign="space-between" verticalAlign="start">
        <FullWidthHeader title={renderHeader} />
        <StackItem className={classes.filterItem}>
          <ListFilter filterState={filterState} setFilterState={setFilterState} />
        </StackItem>
      </Stack>
      <div className={`${bodyContentContainer}  ms-depth-4`}>
        {WrappedListPage(ProcessExtensionsList, wrappedListPageParams)}
      </div>
    </>
  );
};

export default ProcessExtensionsListPage;
